<template lang="pug">
  nuxt-link(
    :to="`/${prefix}/${item.id}`"
    :data-test="`${prefix}-title-${index}`"
  ) {{ value }}
</template>

<script>
export default {
  name: 'ELinkEntityPage',
  props: {
    value: {
      type: String,
      default: null
    },
    item: {
      type: Object,
      default: () => ({})
    },
    prefix: {
      type: String,
      default: null
    },
    index: {
      type: Number,
      default: undefined
    }
  }
}
</script>

<style scoped lang="scss"></style>
